import React from 'react';
import styled from 'styled-components';
import Footer from '../Components/Footer';
import Navbar from '../Components/Navbar';
import Home from '../Components/Home';
import { motion } from 'framer-motion';

function OnePage() {
  return (
    <OnePageStyle>
      <Navbar />
      <Home />
      <Footer />
    </OnePageStyle>
  );
}

const OnePageStyle = styled(motion.div)``;

export default OnePage;
